export class ExtensionNotInstalledException extends Error {
  constructor(message = 'Extension not installed or inaccessible') {
    super(message);
  }
}
